/**
 * Nederlandse teksten voor de schil van de app, in de jij-vorm.
 *
 * De 404 zegt wat er aan de hand is zonder dat het klinkt alsof de app onaf is:
 * de pagina bestaat niet (meer), en meestal ligt dat aan de link.
 */
export const shellCopy = {
    notFound: {
        title: 'Pagina niet gevonden',
        body: 'Deze pagina bestaat niet (meer). Misschien is de link oud of verkeerd overgenomen.',
        next: 'Ga verder vanaf het dashboard of zoek de keuring op bij Keuringen.',
        toDashboard: 'Naar het dashboard',
        toInspections: 'Naar Keuringen',
    },
} as const;
